import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { MetaService } from '@sparro/app/core/helpers/meta/meta.service';
import { PreviewPaneComponent, PreviewPaneData } from '@sparro/app/shared/components/dialogs/preview-pane/preview-pane.component';

import { UniApiConfig } from '@sparro/app/core/config/api.config';
import { ALLOWED_HOSTS, UNI_CONSTANTS } from '@sparro/app/core/config/constants.config';
import { Project } from '@sparro/app/core/models/project.model';
import { User } from '@sparro/app/core/models/user.model';
import { ProjectService } from '@sparro/app/core/api/project/project.service';


@Component({
  selector: 'uni-project-card',
  templateUrl: './project-card.component.html',
  styleUrls: ['./project-card.component.scss']
})
export class ProjectCardComponent implements OnInit {
  @Input() project: Project;
  @Input() version: string = 'latest';
  @Input() featured: boolean = false;
  @Input() containerWidth: number = null;

  // Sets redirection action
  @Input() host: ALLOWED_HOSTS;
  dialogOpenable: boolean = true;

  // Sets footer type for card
  @Input() footerType: string; // Deprecating soon

  // Sets border for card
  @Input() border: string; // Deprecating soon

  // Sets user header
  @Input() showUsers: boolean = true; // Deprecating soon

  // Sets style and hover to image
  @Input() imageHover: boolean; // Deprecating soon

  // Sets edit or read view
  @Input() user: User;
  self: boolean = false;

  // Truncates description into one line
  @Input() truncate: boolean; // Deprecating soon

  // Sets description content
  @Input() contentType: string; // Deprecating soon

  default: string;

  owner: any;

  @ViewChild('card', { read: ElementRef }) card: ElementRef;
  @Output() removedProject = new EventEmitter();
  projectSchema: {[key: string]: any};

  constructor(
    public breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private apiconfig: UniApiConfig,
    public router: Router,
    public route: ActivatedRoute,
    public metaService: MetaService,
    private projectService: ProjectService
  ) { }

  ngOnInit(): void {
    // console.log(this.containerWidth, 'hi');
    if (
      this.host === UNI_CONSTANTS.HOSTS.EVALUATION ||
      (this.host === UNI_CONSTANTS.HOSTS.PROFILE && !this.project?.ever_published)
    ) {
      this.dialogOpenable = false;
    }
    this.checkOwner();

    if (this.host === UNI_CONSTANTS.HOSTS.EVALUATION) {
      this.showUsers = false;
    }
    if(this.project) {
      this.projectSchema = this.metaService.createProjectSchema(this.project);
    }
  }

  checkOwner(): void {
    //Commented for now. will update once project service method is finalized
    // this.self = this.projectService.checkOwner(this.project.uuid, this.project.slug);
    // console.log(this.self)
    // console.log(this.project);
    this.project?.owners?.forEach((owner) => {
      if (owner.user.username === this.user?.username) {
        this.self = true;
      }
    });
  }

  openProjectDialog(): void {
    const previewData: PreviewPaneData = {
      slug: this.project.slug,
      entityType: this.apiconfig.projectUrl,
      projectVersion: this.version
    };
    this.dialog.open(PreviewPaneComponent, {
      height: '90vh',
      width: '80vw',
      data: previewData
    });
  }

  removeProject(event): void {
    this.removedProject.emit(event);
  }
}
